import { render } from "./app-breadcrumbs.vue?vue&type=template&id=000d0061&scoped=true&ts=true"
import script from "./app-breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./app-breadcrumbs.vue?vue&type=script&lang=ts"

import "./app-breadcrumbs.vue?vue&type=style&index=0&id=000d0061&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000d0061"]])

export default __exports__